import React, { useEffect } from "react";
import ChartFilters from "./ChartFilters/ChartFilters";
import useChartFilters from "./ChartFilters/useChartFilters";
import ChartItem from "./ChartItem/ChartItem";
import StatContainer from "./StatContainer/StatContainer";
import StatFilters from "./StatFilters/StatFilters";
import StatItem from "./StatItem/StatItem";
import useStats from "./useStats";
import { useAtom } from "jotai";
import { statFiltersAtom } from "./StatFilters/useStatFilters";
import { getLeadAutoStatsParAn } from "../../../../services/graal-api/leadAutoService";

const Stats = () => {
  const {
    isLoadingLead,
    isLoadingDoc,
    isLoadingRenew,
    isLoadingLeadAuto,
    isLoading,
    leadDatas,
    docDatas,
    renewData,
    leadAutoDatas,
    actions,
  } = useStats();
  const { chartFilters } = useChartFilters();
  const [statFilters] = useAtom(statFiltersAtom);

  const buildLeadLink = (product) => {
    const params = new URLSearchParams();
    params.append("products[]", product);
    params.append("statuses[]", "TO_DO");
    params.append("statuses[]", "IN_PROGRESS");

    if (statFilters.beginAt) params.append("beginAt", statFilters.beginAt);
    if (statFilters.endAt) params.append("endAt", statFilters.endAt);

    return `/leads?${params.toString()}`;
  };

  useEffect(() => {
    actions.getLeadStats();
    actions.getLeadAutoStats();
    actions.getDocStats();
    actions.getRenewStats();
  }, []);

  return (
    <>
      <div className="row">
        <div className="col-12 col-md-12">
          <StatFilters statActions={actions} isLoading={isLoading} />
        </div>
        <div className="col-12 col-md-12">
          <StatContainer title="Demandes en cours">
            <StatItem
              isLoading={isLoadingLead}
              total={leadDatas.PJ}
              title="Protection Juridique"
              link={buildLeadLink("PJ")}
            />
            <StatItem
              isLoading={isLoadingLead}
              total={leadDatas.MRP}
              title="Multirisque Professionnelle"
              link={buildLeadLink("MRP")}
            />
            <StatItem
              isLoading={isLoadingLead}
              total={leadDatas.AC}
              title="Assurance Construction"
              link={buildLeadLink("AC")}
            />
            <StatItem
              isLoading={isLoadingLead}
              total={leadDatas.RCPRO}
              title="Responsabilité Civile Pro"
              link={buildLeadLink("RCPRO")}
            />
            <StatItem
              isLoading={isLoadingLead}
              total={leadDatas.CYBER}
              title="Assurance Cyber"
              link={buildLeadLink("CYBER")}
            />
            {Object.entries(leadAutoDatas).map(([key, value]) => {
              const autoParams = new URLSearchParams();
              autoParams.append("statuses[]", "TO_DO");
              autoParams.append("statuses[]", "IN_PROGRESS");
              return (
                <StatItem
                  key={key}
                  isLoading={isLoadingLeadAuto}
                  total={value}
                  title={"Assurance Auto"}
                  link={`/leads-auto?${autoParams.toString()}`}
                />
              );
            })}
          </StatContainer>
        </div>
        <div className="col-12 col-md-6">
          <StatContainer title="Renouvellements PJ en attente">
            <StatItem
              isLoading={isLoadingRenew}
              total={renewData.RENEWABLE}
              title="Échéance dépassée"
              link="/pj-renew?renewableInNbDays=-1"
            />
            <StatItem
              isLoading={isLoadingRenew}
              total={renewData.RENEWABLE_30DAYS}
              title="Échéance dans moins de 30 jours"
              link="/pj-renew?renewableInNbDays=30"
            />
          </StatContainer>
        </div>
        <div className="col-12 col-md-6">
          <StatContainer title="Contrats aux documents manquants">
            <StatItem
              isLoading={isLoadingDoc}
              total={docDatas.CP_MISSING}
              title="Conditions Particulières"
              link="/files?entityModel=Amendment&fileTypes[]=CP&isExist=false&activeUsersOnly=true"
            />
            <StatItem
              isLoading={isLoadingDoc}
              total={docDatas.ATTESTATION_MISSING}
              title="Attestations manquantes"
              link="/files?entityModel=Amendment&fileTypes[]=ATT_ASSU_CONT&isExist=false&activeUsersOnly=true"
            />
            <StatItem
              isLoading={isLoadingDoc}
              total={docDatas.ATTESTATION_EXPIRED}
              title="Attestations périmées"
              link="/files?entityModel=Amendment&fileTypes[]=ATT_ASSU_CONT&isExist=true&activeUsersOnly=true"
            />
          </StatContainer>
        </div>
      </div>
      <div className="row">
        <div className="col-12">
          <StatContainer title="Flux des leads par mois">
            <div className="d-flex w-100 ">
              <ChartFilters />
            </div>
            <ChartItem
              url="statistics/leads"
              postData={chartFilters}
              additionalFetchers={[getLeadAutoStatsParAn]}
            />
          </StatContainer>
        </div>
      </div>
    </>
  );
};

export default Stats;
